// 处理响应数据的公共函数
export function handleResponse(xhr: XMLHttpRequest) {
  let responseText;
  try {
    responseText = JSON.parse(xhr.responseText);
  } catch (e) {
    responseText = xhr.responseText;
  }
  return responseText;
}

// 创建并配置 XHR 的公共函数
export function createXHR(method: string, url: string, contentType?: string) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url, true);
  if (contentType) {
    xhr.setRequestHeader('Content-Type', contentType);
  }
  return xhr;
}

export function get(data: { url: string }, fn?: Function, errFn?: Function) {
  const xhr = createXHR('GET', data.url);
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      const responseText = handleResponse(xhr);
      if (xhr.status === 200 || xhr.status === 304) {
        fn && fn.call(this, responseText);
      } else {
        errFn && errFn.call(this, responseText);
      }
    }
  };
  xhr.send();
}

export function post(data: { url: string, contentType?: string, data?: any }, fn?: Function) {
  const xhr = createXHR('POST', data.url, data.contentType || 'application/json');
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && (xhr.status === 200 || xhr.status === 304)) {
      const responseText = handleResponse(xhr);
      fn && fn.call(this, responseText);
    }
  };
  xhr.send(data.data);
}